import {
    ItemBag,
    ItemBlocks,
    ItemBox,
    ItemBoxes,
    ItemCalendar,
    ItemGift,
    ItemMoney,
    ItemStopwatch,
} from './assets/images';

import { colors } from './styles/variables';

import {
    heroRef,
    howItWorksRef,
    benefitsRef,
    faqRef,
    opinionsRef,
    contactRef,
} from './utils/sectionRefs';

export const START_NAVBAR_CONFIG = {
    navigationLinks: [
        {
            id: 1,
            name: "Jak to działa?",
            relatedSection: howItWorksRef.forwardedRef,
            action: () => howItWorksRef.moveToSection(),

        },
        {
            id: 2,
            name: "Korzyści",
            relatedSection: benefitsRef.forwardedRef,
            action: () => benefitsRef.moveToSection(),
        },
        {
            id: 3,
            name: "FAQ",
            relatedSection: faqRef.forwardedRef,
            action: () => faqRef.moveToSection(),
        },
        {
            id: 4,
            name: "Opinie",
            relatedSection: opinionsRef.forwardedRef,
            action: () => opinionsRef.moveToSection(),
        },
        {
            id: 5,
            name: "Kontakt",
            relatedSection: contactRef.forwardedRef,
            action: () => contactRef.moveToSection(),
        },
    ],
};

export const START_HERO_CONFIG = {
    title: "Kup teraz, zapłać za 30 dni lub później",
    id: "section-hero",
    forwardedRef: heroRef.forwardedRef,
    subtitle: "Z PayPo możesz zapłacić w 4 prostych ratach",
    content: [
        {
            text: "Zamawiasz jak zwykle w sklepach obsługiwanych przez PayPo. Odbierasz zakupy, sprawdzasz, czy Ci pasują czy nie. I płacisz nawet 30 dni po złożeniu zamówienia. Bez żadnych dodatkowych kosztów i rejestracji.",
        },
        {
            text: "Bo możesz."
        },
    ],
};

export const START_ORDERED_ITEMS_CONFIG = {
    title: "Jak to działa",
    id: "section-how-it-works",
    forwardedRef: howItWorksRef.forwardedRef,
    itemList: [
        {
            id: 1,
            title: "Krok 1",
            text: "Robiąc zakupy online, dodajesz produkty do koszyka i wybierasz PayPo jako metodę płatności.",
        },
        {
            id: 2,
            title: "Krok 2",
            text: "Jeśli nie masz jeszcze konta w PayPo, to podajesz swoje dane. Przy kolejnych zakupach potwierdzasz transakcję wyłącznie kodem SMS.",
        },
        {
            id: 3,
            title: "Krok 3",
            text: "PayPo opłaca Twoje zakupy internetowe w sklepie, a Ty otrzymujesz swoje zamówienie.",
        },
        {
            id: 4,
            title: "Krok 4",
            text: "Sprawdzasz zakupy w domu, a na spłatę należności dla PayPo masz aż 30 dni. Pamiętaj, że płacisz tylko za te produkty, które zatrzymasz.",
        }
    ],
    squares: [
        {
            top: "11.5rem",
            left: "-17rem",
            size: "20rem",
            bgColor: colors.paypoGreen500,
            rotate: "45deg",
        }
    ],
};

export const START_VIDEO_CONTAINER_CONFIG = {
    videoId: "v_uzBRJeZOU",
    squares: [
        {
            top: "6rem",
            left: "7.2rem",
            size: "4.8rem",
            bgColor: colors.fuchsia500,
            rotate: "81.39deg",
        },
        {
            top: "33rem",
            right: "7.2rem",
            size: "4.8rem",
            bgColor: colors.fuchsia500,
            rotate: "20.46deg",
        },
        {
            top: "11rem",
            right: "-15.5rem",
            size: "20rem",
            bgColor: colors.yellow500,
            rotate: "69.24deg",
        },
    ],
};

export const START_ICON_ITEMS_CONFIG = {
    title: "Korzyści",
    id: "section-benefits",
    forwardedRef: benefitsRef.forwardedRef,
    content: [
        {
            Icon: ItemCalendar,
            description: "Masz aż 30 dni na zapłatę - <b>bez dodatkowych kosztów</b>",
        },
        {
            Icon: ItemBlocks,
            description: "Jeśli potrzebujesz więcej czasu i swobody - <b>możesz rozłożyć płatność na wygodne raty</b>",
        },
        {
            Icon: ItemBoxes,
            description: "<b>Sprawdzasz produkty w domu</b> - nieudane zakupy odsyłasz, płacisz tylko za te, które zatrzymasz",
        },
        {
            Icon: ItemGift,
            description: "<b>Możesz pozwolić sobie na więcej</b> - zrobić prezent sobie lub bliskim albo zaszaleć na wyprzedaży",
        },
        {
            Icon: ItemBag,
            description: "Kupujesz bezpiecznie - płacisz tylko wtedy, kiedy otrzymasz przesyłkę - <b>chroni Cię Gwarancja Ochrony Kupującego</b>",
        },
        {
            Icon: ItemBox,
            description: "Płatność PayPo zabezpiecza Cię <b>lepiej i taniej niż przesyłka za pobraniem</b>",
        },
        {
            Icon: ItemMoney,
            description: "Z czasem możesz jeszcze więcej - <b>Twój limit na kolejne zakupy może wzrosnąć aż do 2500zł</b>",
        },
        {
            Icon: ItemStopwatch,
            description: "<b>Błyskawiczne i bezpieczne płatności</b> - kolejne transakcje potwierdzasz tylko kodem SMS",
        },
    ],
    squares: [
        {
            bottom: "-14rem",
            right: "-13rem",
            size: "20rem",
            bgColor: colors.yellow500,
            rotate: "69.24deg",
        },
    ],
};

export const START_ACCORDION_SECTION = {
    title: "Najczęściej zadawane pytania",
    id: "section-faq",
    forwardedRef: faqRef.forwardedRef,
    content: [
        {
            id: "1",
            title: "1. Czy muszę podawać dane swojej karty kredytowej/debetowej?",
            text: "Nie. Do skorzystania z płatności PayPo wystarczą podstawowe informacje podane w formularzu rejestracyjnym. Dostęp do panelu Klienta ze wszystkimi informacjami na temat zamówienia otrzymasz mailem, wysłanym na podany przez Ciebie adres e-mail.",
            isExpanded: true,
        },
        {
            id: "2",
            title: "2. W jaki sposób płacę za zamówienie?",
            text: "Możesz zapłacić przelewem bankowym, przekazem pocztowym lub szybkimi płatnościami online - jak Ci wygodniej. Numer konta do wpłaty otrzymasz mailem wraz z potwierdzeniem złożenia zamówienia. Dla Twojej wygody udostępniamy panel Klienta - nie masz obowiązku logować się do niego, ale możesz. Tam masz bieżący podgląd wszystkich ważnych informacji.",
        },
        {
            id: "3",
            title: "3. Czy to jest bezpieczne?",
            text: "Tak, wszystkie płatności są realizowane w ramach szyfrowanego połączenia, a Ty nie podajesz żadnych danych dostępowych do swojego konta.",
        },
        {
            id: "4",
            title: "4. Czy to coś kosztuje?",
            text: "Nie. Korzystając z płatności PayPo w ciągu 30 dni zapłacisz tylko tyle, ile wynosi wartość zamówienia - bez dodatkowych opłat. W przypadku spłaty w ratach, Ofertę dla Ciebie prezentujemy w podsumowaniu mail, Umowie, w panelu Klienta. Nie musisz decydować się od razu.",
        },
        {
            id: "5",
            title: "5. Co jeśli nie zapłacę w ciągu 30 dni?",
            text: "Nie martw się, nic sie nie stanie. Twoja płatność zostanie automatycznie rozłożona na 4 wygodne raty.",
        },
        {
            id: "6",
            title: "6. Co się stanie, jeśli zwrócę zamówienie?",
            text: "Po prostu nie zapłacisz. Twoja transakcja zostanie anulowana w naszym systemie.",
        },
    ],
    squares: [
        {
            top: "54rem",
            left: "13rem",
            size: "6rem",
            bgColor: colors.fuchsia500,
            rotate: "78.54deg",
        },
        {
            top: "6rem",
            right: "10rem",
            size: "10rem",
            bgColor: colors.fuchsia500,
            rotate: "20.46deg",
        },
        {
            top: "-6rem",
            right: "-13rem",
            size: "20rem",
            bgColor: colors.yellow500,
            rotate: "69.24deg",
        },
    ],
};

export const START_INLINE_TILES_CONFIG = {
    title: "Zobacz ponad 6500 pozytywnych opinii",
    id: "section-opinions",
    forwardedRef: opinionsRef.forwardedRef,
    tileList: [
        {
            id: 1,
            score: '5.0',
            name: "Edyta",
            text: "Jak dla mnie rewelacja. Mogę zobaczyć i przymierzyć ubrania, buty przed dokonaniem płatności, nie blokując środków na koncie. Polecam wszystkim.",
        },
        {
            id: 2,
            score: '5.0',
            name: "Lidia",
            text: "Bardzo dobra firma na zakupy, kupuję dziś, płacę za 30 dni, gdy w danym momencie brak gotówki, bardzo dobra opcja.",
        },
        {
            id: 3,
            score: '5.0',
            name: "Ola",
            text: "Polecam. Bez problemu mogę sobie pozwolić na większe zakupy. Jak dla mnie super opcja.",
        },
    ],
    cta: {
        type: "button",
        text: "Zobacz opinie na Opineo",
        link: "https://www.opineo.pl/opinie/paypo-pl",
    },
    squares: [
        {
            bottom: "18rem",
            left: "-8rem",
            size: "10rem",
            bgColor: colors.fuchsia500,
            rotate: "20.46deg",
        },
        {
            bottom: "-4.8rem",
            left: "-12rem",
            size: "20rem",
            bgColor: colors.yellow500,
            rotate: "69.24deg",
        },
        {
            top: "24.8rem",
            right: "31rem",
            size: "14rem",
            bgColor: colors.paypoGreen500,
            rotate: "69.24deg",
        },
    ],
};

export const START_BIG_TILES_CONFIG = {
    title: "Masz pytanie?",
    id: "section-contact",
    forwardedRef: contactRef.forwardedRef,
    tileList: [
        {
            id: 1,
            bgColor: colors.mintCream,
            content: {
                title: "bok@paypo.pl",
                text: "Na większość pytań odpowiadamy w ciągu 48 godzin",
                cta: {
                    type: "button",
                    action: "email",
                    text: "Napisz do nas"
                }
            },
        },
        {
            id: 2,
            bgColor: colors.palePurple,
            content: {
                title: "+48 22 333 74 60",
                text: "Od poniedziałku do piątku od 8:00 do 18:00",
                cta: {
                    type: "textButton",
                    action: "phoneCall",
                    text: "Zadzwoń do nas",
                },
            },
        },
    ],
    squares: [
        {
            top: "-15.2rem",
            left: "-12rem",
            size: "20rem",
            bgColor: colors.yellow500,
            rotate: "69.24deg",
        },
    ],
};


